/**
 *
 * CardContent
 *
 */

import React from 'react';

import PropTypes from 'prop-types';
import { StyledCardContent } from './Card.styles';

function CardContent({ size, ...props }) {
  return <StyledCardContent size={size} {...props} />;
}

CardContent.propTypes = {
  size: PropTypes.string,
};

export default CardContent;
